import moment from "moment";

export default class ReceiptStatusEvent 
{
    constructor(receiptId, tagId, gcid, eventStatus, description, statusDateTime, statusBy, successful, messages )
    {
        this.receiptId = receiptId || "";
        this.tagId = tagId.toString() || "";
        this.gcid = gcid || "";
        this.eventStatus = eventStatus || "";
        this.description = description || "";
        this.statusDateTime = statusDateTime || moment().format();
        this.statusBy = statusBy || "";
        this.source = "MSA-USR-APP";
        this.successful = successful || true;
        this.messages = messages || [];


    }
}